export default "__VITE_ASSET__CStNh9eM__"